"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Popover = void 0;
var react_1 = __importDefault(require("react"));
var Popper_1 = require("../../internal/Popper");
var classnames_1 = __importDefault(require("classnames"));
var hooks_1 = require("../../hooks");
var focus_utils_1 = require("../../utilities/focus-utils");
var components_1 = require("./components");
exports.Popover = react_1.default.forwardRef(function (_a, ref) {
    var _b;
    var _c = _a.width, width = _c === void 0 ? 's' : _c, _d = _a.padding, padding = _d === void 0 ? 'm' : _d, _e = _a.portal, portal = _e === void 0 ? false : _e, children = _a.children, className = _a.className, contentNoPadding = _a.contentNoPadding, footer = _a.footer, footerAlign = _a.footerAlign, header = _a.header, headerAlign = _a.headerAlign, headerNoPadding = _a.headerNoPadding, popoverContentClassName = _a.popoverContentClassName, scrollHeight = _a.scrollHeight, sharp = _a.sharp, wrapperClassName = _a.wrapperClassName, open = _a.open, focusScopeOptions = _a.focusScopeOptions, _f = _a.offset, offset = _f === void 0 ? { skidding: 0, distance: 4 } : _f, props = __rest(_a, ["width", "padding", "portal", "children", "className", "contentNoPadding", "footer", "footerAlign", "header", "headerAlign", "headerNoPadding", "popoverContentClassName", "scrollHeight", "sharp", "wrapperClassName", "open", "focusScopeOptions", "offset"]);
    var PopoverBaseWidth = 16;
    var contentRef = react_1.default.useRef();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var lastActiveElement = react_1.default.useMemo(function () { return focus_utils_1.getActiveElement(); }, [
        open,
    ]);
    var handleTab = hooks_1.useFocusScope(contentRef, __assign({ disableAutofocus: true, disableTrapping: true, restoreFocusRef: { current: lastActiveElement } }, focusScopeOptions)).handleTab;
    var widthSwitch = function () {
        switch (width) {
            case 'l':
                return PopoverBaseWidth * 40;
            case 'm':
                return PopoverBaseWidth * 32;
            case 's':
                return PopoverBaseWidth * 20;
            case 'xs':
                return PopoverBaseWidth * 12;
            case '100':
                return "100";
            default:
                return "auto";
        }
    };
    var PopoverBodyClasses = classnames_1.default('Popover__body', className, (_b = {},
        _b["Popover--p-" + padding] = padding,
        _b["Popover--w-auto"] = width === 'auto',
        _b['Popover__body--sharp'] = sharp,
        _b['Popover__body--portal'] = portal,
        _b['Popover__body--open'] = open,
        _b));
    var PopoverClasses = classnames_1.default('Popover', wrapperClassName, {
        'Popover--portal': portal,
        'Popover--open': open,
    });
    return (react_1.default.createElement(Popper_1.Popper, __assign({ className: PopoverClasses, bodyClassName: PopoverBodyClasses, width: widthSwitch(), overlayContext: "popover", portal: portal, ref: ref, open: open, offset: offset }, props),
        header && (react_1.default.createElement(components_1.PopoverHeader, { noPadding: headerNoPadding, align: headerAlign }, header)),
        react_1.default.createElement(components_1.PopoverContent, { contentScrollHeight: scrollHeight, noPadding: contentNoPadding, className: popoverContentClassName, onKeyDown: handleTab, ref: contentRef }, children),
        footer && (react_1.default.createElement(components_1.PopoverFooter, { align: footerAlign }, footer))));
});
exports.Popover.Header = components_1.PopoverHeader;
exports.Popover.Footer = components_1.PopoverFooter;
exports.Popover.Content = components_1.PopoverContent;
exports.Popover.Divider = components_1.PopoverDivider;
//# sourceMappingURL=Popover.js.map